import url from './apiUrl'
import handleResponse from './handleResponse'

export default (token, page, tag, year, mediaType) => {

    const dehashedTag = tag.replace('#','').trim()

    return fetch(`${url()}/posts/tags/${page}/${dehashedTag}/${year}?mediaType=${mediaType}`,{
                method: 'GET',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": token
                }
            })
            .then(res => handleResponse(res))
}